import {
  GET_SELLER_AFFIDAVIT_GRID,
  GET_SELLER_AFFIDAVIT_GRID_ERROR,
  GET_SELLER_AFFIDAVIT_GRID_SUCCESS
} from './PartnershipGridSection.actions'

const partnershipGridSectionState = {
  error: null,
  hasAffidavit: false,
  isForcedAffidavit: false,
  loading: true,
  otherPartners: null,
  partnerships: [],
  taxPayerType: null
}

/**
 * The partnership grid section's reducer.
 */
const partnershipGridSectionReducer = (state = partnershipGridSectionState, { payload, type }) => {
  switch (type) {
    case GET_SELLER_AFFIDAVIT_GRID: {
      return {
        ...state,
        loading: true
      }
    }
    case GET_SELLER_AFFIDAVIT_GRID_ERROR: {
      return {
        ...state,
        error: payload.error,
        loading: false
      }
    }
    case GET_SELLER_AFFIDAVIT_GRID_SUCCESS: {
      return {
        ...state,
        hasAffidavit: payload.hasAffidavit,
        isForcedAffidavit: payload.isForcedAffidavit,
        loading: false,
        otherPartners: payload.otherPartners,
        partnerships: payload.partnerships,
        taxPayerType: payload.taxPayerType
      }
    }
    default: {
      return state
    }
  }
}

export default partnershipGridSectionReducer
